import React from 'react';
import './index.scss';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import {Link} from 'react-router-dom'
import moment from 'moment'

import { Checkbox, InputBase}  from '@material-ui/core';


import Icon from '@mdi/react'
import { mdiDotsVertical, mdiArrowDown,mdiCloudUpload, mdiCloudDownload, mdiPlus, mdiPencil} from '@mdi/js'

import CustomIconButton from '../../basic/customIconButton'

import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';
import uuid from 'uuid4'

import {isMobileSafari} from 'react-device-detect';

@inject('internal')
@inject('translate')
@observer
export default class CustomTable2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: toJS(this.props.internal.dataForTable.meta.order[0].dir),
            orderBy: toJS(this.props.internal.dataForTable.meta.order[0].by),
            checkedRows: [],
            color: null,
            selectAll: false,
            isIOS: false,
        }
    }

    parameters = [
        {
            id: 0,
            title_web: "Typ",
            title_backend: "Typ (náradie, nástroje, záhr.doplnky-all)",
            param_type: "Viac parametrov",
            param_value_count: 10,
            action: "+"
        },
        {
            id: 1,
            title_web: "Materiál",
            title_backend: "Materiál (nity)",
            param_type: "Jeden parameter",
            param_value_count: 2,
            action: "+"
        },
        {
            id: 2,
            title_web: "Na výšku brány",
            title_backend: "Vjazd.brány-Výška brány (pohony)",
            param_type: "Jeden parameter",
            param_value_count: 5,
            action: "+"
        },
        {
            id: 3,
            title_web: "Vyhotovenie",
            title_backend: "Vyhotovenie (lepidlá, spreje)",
            param_type: "Textovy parameter",
            param_value_count: 7,
            action: "+"
        }
    ]

    componentDidMount() {
        // let tmpData = toJS(this.props.internal.dataForTable);
        // tmpData.data = this.parameters;
        // this.props.internal.setDataForTable(tmpData)
        if(isMobileSafari) {
            this.setState({isIOS: true})
        }
     }
    
    createSortHandler = (orderBy) => {
        let currentOrder = this.state.order;
        this.setState({orderBy: orderBy});
        if(currentOrder === 'asc') {
            this.setState({order: "desc"}, () => {
                this.props.handleSort(this.state.order, this.state.orderBy);
            })
        }
        else {
            this.setState({order: "asc"}, () => {
                this.props.handleSort(this.state.order, this.state.orderBy);
            })
        }
    }

    handleChangePage = (event, page) => {
        this.props.handleChangePage(page);
    };
    
    handleChangeRowsPerPage = event => {
        let numberOfRows;
        if(event.target.value === this.props.translate.i18n.GLOBAL.TABLE.ALL) {
            numberOfRows = Number(toJS(this.props.internal.dataForTable.meta.total))
        }
        else {
            numberOfRows = event.target.value
        }
        this.props.handleChangeRowsPerPage(numberOfRows);
        this.props.internal.administrators = [];
    };

    createWrap = (data, type) => {
        if(type === "email"){
            let mailto = `mailto:${data[type]}`
            return <a href={mailto}>{data[type]}</a>
        }
        else if(type === "phone") {
            let tel = `tel:${data[type]}`
            return <a href={tel}>{data[type]}</a>
        }
        else if(type === "clients_count") {
            return <Link to={`/administrators/${data.id}/edit/tab=2`}>{data[type]}</Link>
        }
        else if(type === "role_name") {
            let tmpData = data[type].toUpperCase()
            return this.props.translate.i18n.MODULES.CLIENTS.ROLES[tmpData]
        }
        else if(type === "role_id") {
            return this.props.translate.i18n.GLOBAL.ROLES[data[type]]
        }
        else if(type === "document_type") {
            let tmpData = data[type].toUpperCase()
            return this.props.translate.i18n.GLOBAL.DOC_TYPES[tmpData]
        }
        else if(type === "warehouse_status_name") {
            let tmpData = data[type].toUpperCase()
            if(data[type] === 'available' ) {
                if(data['warehouse_info'] > 0 && data['warehouse_info'] <=5) {
                    return this.props.translate.i18n.MODULES.PRODUCTS.AVAILABLE_LESS
                }
                else {
                    return this.props.translate.i18n.MODULES.PRODUCTS[tmpData]
                }
            }
            else{
                return this.props.translate.i18n.MODULES.PRODUCTS[tmpData]
            }
            
        }
        else if(type === "created_at" || type === "updated_at") {
            let date = moment(data[type]).format("DD.MM.YYYY HH:mm")
            return date;

        }
        else if(type === "retail_price" || type === "total" || type === "client_price" || type === "free_from" || type === "price") {
            const formatter = new Intl.NumberFormat('sk-SK', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            })
            return <div style={{textAlign:"right"}}>{formatter.format(data[type])}</div>
        }
        else if(type === "production") {
            if(data[type] === true){
                return( <div style={{textAlign: "center"}} className={'production-icon'} onClick={() => this.props.clickOnProductionStatus(data.id, false)}><Icon path={mdiCloudUpload} size={1} className={`production-${data[type]}`} /> </div>)
            }
            else{
                return (<div style={{textAlign: "center"}} className={'production-icon'} onClick={() => this.props.clickOnProductionStatus(data.id, true)}><Icon path={mdiCloudDownload} size={1} className={`production-${data[type]}`} /></div>)
            }    
        }
        else if(type === "tags") {
            return <div className={'tags'}>
                {data[type].map((tag, index) => {
                    return <span key={tag.id} style={{backgroundColor: tag.color}} className={'tag'}>{tag.name}</span>
                })}
            </div>
        }
        else if(type === "status") {
            let tmp = data[type].toUpperCase();
            return this.props.translate.i18n.MODULES.CLIENTS.OREDER_STATE[tmp]
        }
        else if(type === "color") {
            
            return <span className={'color-tag'} style={{backgroundColor:data[type]}}></span>
        }
        else if(type === "available") {
            let available = data[type] ? "#79C552" : "#ee5c4e"
            return <span className={'available'} style={{backgroundColor:available}}></span>
        }
        else if(type === 'products_count') {
            return <a href={`/products?tags=${data.id}`}>{data[type]}</a>
        }
        else if(type === 'action') {
            if(data['parameter_type_id'] !== 3) {
                return <Tooltip title={this.props.translate.i18n.MODULES.PARAMETERS.CHANGE_PARTAMETER_VALUES}><div onClick={() => this.props.changeParameterValues(data.id)}><Icon path={mdiPencil} size={1} className={'btn-action-plus'} /></div></Tooltip>
            }    
        }
        else if(type === 'parameter_type_id') {
            // data[type] - hodnoty [1,2,3] repreezentujuce typ parametru (1-jedna hodnota, 2-viac hodnot, 3-textova hodnota)
            return this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER_TYPES_NUMBER[data[type]]
        }
        else if(type === 'items_count') {
            if(data['parameter_type_id'] === 3) {
                return "N/A"
            } 
            else {
                return data['items_count']
            }
        }
        else {
            return data[type]
        }
    }

    handleCheckRow = (rowId) => {
        let checkedRow = this.state.checkedRows;
        let newChecked = []
        let rowIsNotChecked = false;
        checkedRow.filter(function(data) {
            if(data !== rowId) {
                newChecked.push(data)
            }
            else {
                rowIsNotChecked = true
            }
            return null
        })

        if(!rowIsNotChecked) {
            newChecked.push(rowId)
        }
        
        this.setState({checkedRows: newChecked, selectAll: false }, () => {
            this.props.internal.setCheckedRows(this.state.checkedRows)
        })
    }

    handleSelectAll = event => {
        if (event.target.checked) {
            this.setState({ checkedRows: this.props.internal.dataForTable.data.map(n => n.id), selectAll: true }, () => {
                this.props.internal.setCheckedRows(this.state.checkedRows)
            
            })
        }
        else {
            this.setState({ checkedRows: [], selectAll: false  }, () => {
                this.props.internal.setCheckedRows(this.state.checkedRows);
            })
        }
          
    }


    render() {
        let MODULE = this.props.module.substring(1).toUpperCase()
        return (
            <div className={'custom-table'}>
            <Paper className={`table-box ${this.state.isIOS ? 'ios' : ''}`} > 
                <Table >
                    <TableHead>
                    <TableRow>
                        {this.props.firstCellCheckbox 
                            ? 
                            <TableCell className={'firstCellCheckbox'} onClick={this.handleSelectAll}>
                                <Checkbox
                                    value={''}
                                    checked={this.state.selectAll}
                                    className={'custom-checkbox'}
                                />
                            </TableCell>
                            :
                            null
                        }
                            
                            <TableCell></TableCell>
                        {this.props.header.map((data, index) => {
                            let DATA = data.title.toUpperCase();
                            return (
                                <TableCell 
                                    key={uuid()} 
                                    onClick={this.props.disableSort || data.disabled ? null : () =>this.createSortHandler(data.sortBy?data.sortBy: data.title)} 
                                    numeric={data.numeric}
                                    style={{textAlign:data.textAlign, minWidth: data.min_width ? data.min_width : 0}}
                                >
                                    
                                    {this.props.translate.i18n.MODULES[MODULE][DATA]}
                                        {this.props.disableSort 
                                            ?
                                            null
                                            :
                                            this.state.orderBy === data.title || this.state.orderBy === data.sortBy ? 
                                                <Icon path={mdiArrowDown} size={1} className={this.state.order === 'desc' ? ' desc' : 'asc'} />
                                                : null
                                        }
                                </TableCell>
                            );
                        })}
                           
                        
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {(this.props.internal.dataForTable.data).length === 0 ?
                        <TableRow ><TableCell colSpan={this.props.firstCellCheckbox ? this.props.body.length + 2 : this.props.body.length + 1} style={{textAlign:'center'}}>{this.props.translate.i18n.GLOBAL.ALERTS.NO_FOUND_DATA_FOR_TABE}</TableCell></TableRow>
                        :
                            
                            this.state.checkedRows && this.props.internal.dataForTable.data.map(data => {
                                return (
                                    <TableRow key={data.id} className={'body-row'}>
                                        {this.props.firstCellCheckbox 
                                            ?
                                            <TableCell className={'firstCellCheckbox'} onClick={() => this.handleCheckRow(data.id)}>
                                                <Checkbox
                                                    checked={this.state.checkedRows.includes(data.id)}
                                                    value={data.name}
                                                    className={'custom-checkbox'}
                                                />
                                            </TableCell>
                                            :
                                            null
                                        }
                                        
                                        <TableCell className={'cell-with-icon'}>
                                        {this.props.dropDownMenuItems && this.props.dropDownMenuItems.length > 0 ? 
                                            <CustomIconButton
                                                id={data.id}
                                                label="More"
                                                dropdownMenu
                                                items={this.props.dropDownMenuItems}
                                                module={this.props.module}
                                                data={data}
                                            >
                                                <Icon path={mdiDotsVertical} size={1} />
                                            </CustomIconButton>
                                            :
                                            null
                                        }
                                        </TableCell>
                                            
                                        {this.props.body.map((bodyRowCell, index) => {
                                            return (
                                                <TableCell 
                                                    style={{textAlign: bodyRowCell.textAlign}}
                                                    className={`${bodyRowCell.editable? 'input-editable' : ''} `}
                                                    key={uuid()} 
                                                    numeric={Number.isInteger(data[bodyRowCell.title])}>
                                                        {bodyRowCell.editable ? 
                                                            <InputBase 
                                                                classes={{
                                                                    root: 'inputBaseEditable'
                                                                }}
                                                                defaultValue={data[bodyRowCell.title]} 
                                                                disabled={false}
                                                            />
                                                            :
                                                            this.createWrap(data, bodyRowCell.title)
                                                        }
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })
                        }
                    
                    </TableBody>
                </Table>
                </Paper>

                <TablePagination
                    classes={{caption:"caption", selectIcon: "selectIcon", select: "selectPerPage"}}
                    component="div"
                    rowsPerPageOptions={[5,10,15,25,50, this.props.translate.i18n.GLOBAL.TABLE.ALL]}
                    className={'pagination'}
                    count={Number(toJS(this.props.internal.dataForTable.meta.total))}
                    rowsPerPage={Number(toJS(this.props.internal.dataForTable.meta.per_page))}
                    page={Number(toJS(this.props.internal.dataForTable.meta.current_page)) -1}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    labelDisplayedRows={({from, to, count}) => `${from}-${to} z ${count}`}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    labelRowsPerPage={this.props.translate.i18n.GLOBAL.TABLE.LABEL_ROWS_PER_PAGE}
                    />
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/complex/customTable2/index.js